import type { IconProps } from './types';
import './icons.css';

export default function Gear({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-gear ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M8 1.166c.54 0 1.06.07 1.554.185.276.064.481.295.512.576l.106.968a.834.834 0 0 0 1.164.672l.888-.392a.67.67 0 0 1 .755.154 6.8 6.8 0 0 1 1.56 2.69.67.67 0 0 1-.243.731l-.788.578a.833.833 0 0 0 0 1.344l.788.578c.228.167.326.46.244.73a6.8 6.8 0 0 1-1.56 2.69.67.67 0 0 1-.756.155l-.888-.392a.834.834 0 0 0-1.164.673l-.106.966a.67.67 0 0 1-.512.578A7 7 0 0 1 8 14.833c-.54 0-1.06-.068-1.555-.183a.67.67 0 0 1-.51-.578l-.107-.967a.834.834 0 0 0-1.163-.672l-.89.392a.67.67 0 0 1-.755-.155 6.8 6.8 0 0 1-1.56-2.69.67.67 0 0 1 .245-.73l.788-.578a.834.834 0 0 0-.001-1.345l-.787-.578a.67.67 0 0 1-.244-.73 6.8 6.8 0 0 1 1.56-2.69.67.67 0 0 1 .754-.154l.89.392a.834.834 0 0 0 1.163-.672l.106-.968a.67.67 0 0 1 .512-.576A6.8 6.8 0 0 1 8 1.166M8 2.5q-.402 0-.794.06l-.052.48a2.168 2.168 0 0 1-3.026 1.747l-.44-.193c-.329.414-.599.876-.798 1.372l.392.286a2.17 2.17 0 0 1-.001 3.495l-.39.286c.198.497.468.958.797 1.373l.44-.193a2.167 2.167 0 0 1 3.026 1.747l.052.479q.391.06.794.061.402-.001.794-.061l.052-.479a2.168 2.168 0 0 1 3.027-1.747l.438.193c.33-.415.6-.876.798-1.373l-.39-.286a2.167 2.167 0 0 1 0-3.494l.39-.287a5.5 5.5 0 0 0-.798-1.372l-.438.193A2.167 2.167 0 0 1 8.846 3.04l-.052-.48Q8.402 2.5 8 2.5m0 2.666a2.834 2.834 0 1 1-.001 5.67 2.834 2.834 0 0 1 0-5.67M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
      />
    </svg>
  );
}
